import type { PodBrand } from '@/types/pod'

/**
 * The ChamberFlow pod — branding layer (browser side).
 *
 * SUPERSEDED by the foredesk pod (the same self-sales job under the product's
 * settled public name). Retained until foredesk is proven live on
 * foredesk.co.uk, then removed in the cutover batch. The Batch B UI strings
 * below are neutral placeholders satisfying the contract — this pod is not the
 * one being polished.
 */
export const chamberflowPod: PodBrand = {
  id: 'chamberflow',
  brandName: 'ChamberFlow',
  productName: 'ChamberFlow',
  assistantName: 'Flow',
  tagline: 'The onboarding assistant that answers setup questions and captures enquiries.',
  roleLabel: 'onboarding assistant',
  welcomeIntro:
    'I can tell you what ChamberFlow does, how it works, and what it costs. What would you like to know?',
  starters: [
    'What is ChamberFlow?',
    'How much does it cost?',
    'How does it work?',
  ],
  inputPrompt: 'Ask Flow about ChamberFlow',
  footerNote:
    "Flow answers from ChamberFlow's published material. Anything it can't answer goes to the ChamberFlow team.",
  theme: {
    // Neutral copy of the engine defaults — this pod is superseded (see above)
    // and is not being themed; it just satisfies the contract until cutover.
    '--color-brand-primary': '13 110 138',
    '--color-brand-primary-hover': '9 84 107',
    '--color-brand-accent': '94 197 210',
    '--color-surface-base': '247 250 251',
    '--color-surface-raised': '255 255 255',
    '--color-surface-subtle': '237 244 246',
    '--color-text-primary': '17 32 39',
    '--color-text-muted': '90 110 119',
    '--color-text-danger': '178 47 47',
    '--color-border-subtle': '218 230 233',
  },
  contact: {
    // Confirmed 19 Jul 2026 — the operator's real, monitored inbox.
    email: 'mick@autaimate.com',
  },
}
